import { render, staticRenderFns } from "./acts-stats.vue?vue&type=template&id=3ce8df63"
import script from "./acts-stats.vue?vue&type=script&lang=js"
export * from "./acts-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports